<template>
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.30371 0C2.99532 0 0.303711 2.69161 0.303711 6C0.303711 9.30814 2.99532 12
    6.30371 12C9.61186 12 12.3037 9.30814 12.3037 6C12.3037 2.69161 9.61234 0 6.30371
    0ZM5.52259 9.79465L6.22154 6.82148H4.19093L5.69322 2.97003L5.80029 2.68823H7.71344L7.58922
    2.97148L6.54032 5.4828H8.41625L5.52259 9.79465Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
